module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"next":"Next","fillCompanyInfo":"You must fill the company information before posting a job","vacancyInformation":"Job description"}}')
  delete Component.options._Ctor
}
